module.exports = __webpack_public_path__ + "static/media/beesBoxCloseUp.bca13aa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/beesBoxCloseUp.jpg
// module id = 144
// module chunks = 0